
import './App.css';
import All from './Components/All';


function App() {
  return (
    <div className="App">

<All />

    </div>
  );
}

export default App;
